import { resolveClient } from './supabase';
import type { User } from '@lingaai/types';
import type { SupabaseClient } from '@supabase/supabase-js';

export async function getUsers(tenantId?: string, client?: SupabaseClient): Promise<User[]> {
  const supabase = resolveClient(client);

  let query = supabase.from('users').select('*').order('created_at', { ascending: false });

  if (tenantId) {
    query = query.eq('tenant_id', tenantId);
  }

  const { data, error } = await query;

  if (error) throw error;
  return data as User[];
}

export async function getUsersByPortfolioCompany(portfolioCompanyId: string, client?: SupabaseClient): Promise<User[]> {
  const supabase = resolveClient(client);

  const { data, error } = await supabase.from('users').select('*').eq('portfolio_company_id', portfolioCompanyId).order('created_at', { ascending: false });

  if (error) throw error;
  return data as User[];
}

export async function getUser(userId: string, client?: SupabaseClient): Promise<User> {
  const supabase = resolveClient(client);

  const { data, error } = await supabase.from('users').select('*').eq('id', userId).single();

  if (error) throw error;
  return data as User;
}

export async function createUser(
  data: {
    id: string;
    tenant_id: string | null;
    portfolio_company_id: string | null;
    role: 'super_admin' | 'admin' | 'portco';
    email: string;
    full_name: string | null;
    first_name?: string;
    last_name?: string;
    organization?: string;
    title?: string | null;
    status?: 'pending' | 'approved' | 'rejected' | 'invited';
  },
  client?: SupabaseClient
): Promise<User> {
  const supabase = resolveClient(client);

  const { data: user, error } = await supabase.from('users').insert(data).select().single();

  if (error) throw error;
  return user as User;
}

export async function updateUser(userId: string, updates: Partial<User>, client?: SupabaseClient): Promise<User> {
  const supabase = resolveClient(client);

  const { data, error } = await supabase.from('users').update(updates).eq('id', userId).select().single();

  if (error) throw error;
  return data as User;
}
